const NotFound = () => (
  <div className="p-[2rem] global-container bg-white rounded-[0.5rem]">
    <h5 className="text-center">Not Found</h5>
  </div>
);

export default NotFound;
